<template>
  <a :href="content.link" class="hotel__address" target="_blank">
    <address>
      <p>{{ `${content.address}` }}</p>
      <p>{{ `${content.postal_code} ${content.city}, ${content.state}` }}</p>
    </address>
    <Icon id="arrow" class="hotel__address-icon" />
  </a>
</template>

<script>
import Icon from '@/components/global/Icon.vue'

export default {
  name: 'RightAddressLink',
  components: { Icon },
  props: {
    content: {
      type: Object,
      required: true,
    },
  },
}
</script>
